import type { IntlShape } from "@formatjs/intl";
import { Col, Flex, Form, Input, Row } from "antd";
import { Card } from "../../../common/components/Card.tsx";

type ClientFieldsProps = {
  intl: IntlShape;
};

export const ClientFields = (props: ClientFieldsProps) => {
  const { intl } = props;

  return (
    <Flex vertical gap="middle">
      <Card title={intl.formatMessage({ id: "client_section_details" })}>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              name="legal_name"
              label={intl.formatMessage({ id: "client_legal_name" })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_client_legal_name",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="tax_id"
              label={intl.formatMessage({ id: "client_tax_id" })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_client_tax_id",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="billing_address"
              label={intl.formatMessage({ id: "client_billing_address" })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_client_billing_address",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      <Card title={intl.formatMessage({ id: "client_section_contact" })}>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              name="contact_name"
              label={intl.formatMessage({ id: "client_contact_name" })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_client_contact_name",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="contact_email"
              label={intl.formatMessage({ id: "client_contact_email" })}
              rules={[
                {
                  type: "email",
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_client_contact_email",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              name="contact_phone"
              label={intl.formatMessage({ id: "client_contact_phone" })}
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    id: "validation_message_client_contact_phone",
                  }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Flex>
  );
};
